<template>
<div>
  <table class="min-w-full leading-normal">
    <thead>
      <tr>
        <th
          class="pl-4  border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-primary-200 font-normal"
        >
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal cursor-pointer"
          data-vs-button-="emit-filter-date"
          @click="emitFilter('date')"
        >
        <span v-if="headerActive ==='date'">
          <zt-icon v-if="headerTableSort.date" name="arrow-up"  />
          <zt-icon v-else name="arrow-down"/>
        </span>
          {{$t("message.publishedEforms.columns.sendDate")}}
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal cursor-pointer"
          data-vs-button-="emit-filter-fullname"
          @click="emitFilter('fullname')"
        >
        <span v-if="headerActive ==='fullname'">
          <zt-icon v-if="headerTableSort.fullname" name="arrow-up"  />
          <zt-icon v-else name="arrow-down" />
        </span>
          {{$t("message.publishedEforms.columns.sendBy")}}
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal fixed-height"
        >
          {{$t("message.publishedEforms.columns.docTypes")}}
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal text-center"
        >
          {{$t("message.publishedEforms.columns.recipients")}}
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal cursor-pointer"
          data-vs-button-="emit-filter-status"
          @click="emitFilter('status')"
        >
        <span v-if="headerActive ==='status'">
          <zt-icon v-if="headerTableSort.status" name="arrow-up"  />
          <zt-icon v-else name="arrow-down"/>
        </span>
          {{$t("message.publishedEforms.columns.status")}}
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal"
        >
          {{$t("message.publishedEforms.columns.actions")}}
        </th>
        <th
          class=" py-3 border-b-2 border-t-2 border-zt-dark-100 text-left  text-zt-dark-300 font-normal"
        ></th>
      </tr>
    </thead>
    <tbody class="max-h-full">
      <tr class="group" v-for="(publishedEforms, index) in items" :key="publishedEforms.id">
         <td class="pl-4 border-b border-gray-200">
        </td>
        <td class="py-3 border-b border-gray-200 font-normal">
          {{formatDate(publishedEforms.date)}}
        </td>
        <td class="py-3 border-b border-gray-200 font-normal"> 
          {{publishedEforms.fullname}}
        </td>
        <td class="py-3 border-b border-gray-200 font-normal fixed-height">
          <zt-chip v-if='publishedEforms.template[0] !== null' :data-vs-chip="`tmp-${index}`">
            <span>
              {{publishedEforms.template[0]}}
            </span>
          </zt-chip>
          <zt-chip class="zt-chip-custom ml-2" v-if="publishedEforms.template.length > 1" :data-vs-chip="`tmp-${index}`">
            <div class="cursor-pointer" :title="$t('message.publishedEforms.recipientsModal.viewDetail')" :data-vs-button="`btn-${index}`" @click="showTooltip=true,listTemplates = publishedEforms.template,countTemplates = publishedEforms.count_template">
              +{{publishedEforms.count_template-1}}
            </div>
          </zt-chip>
        </td>
        <td class="py-3 border-b border-gray-200 font-normal text-center"  >
          <div
              @click="showRecipients =true,getRecipients(publishedEforms.id),countRecipients=publishedEforms.quantity"
              :data-vs-button="`pub-${publishedEforms.id}`"
            >
            <zt-chip class="cursor-pointer" :title="$t('message.publishedEforms.recipientsModal.viewRecipients')">
                {{publishedEforms.quantity}}
            </zt-chip>
          </div>
        </td>
        <td class="py-3 border-b border-gray-200 font-normal capitalize">
          <span v-if="publishedEforms.reverted === 't'">
            Revertido
          </span>
          <span v-else>{{publishedEforms.status}}</span>
        </td >
        <td class="py-3 border-b border-gray-200">
          <button
            v-if="publishedEforms.reverted !== 't' && publishedEforms.status !== 'error'"
            class="focus:outline-none actions"
            @click="active = !active, selectedIdMaster = publishedEforms.id"
            :data-vs-button="`status-${index}`"
          >
            <zt-tooltip :text="$t('message.publishedEforms.recipientsModal.revertSend')" position="top" >
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.8698 7.47996L17.4498 7.04996C17.2498 6.83996 16.8898 6.83996 16.6598 7.04996C14.4098 9.32996 12.1698 11.59 9.91984 13.85C8.72984 12.63 7.52984 11.43 6.33984 10.23C6.11984 10.01 5.75983 10.01 5.53983 10.23C5.39983 10.37 5.26984 10.51 5.12984 10.66C4.90984 10.87 4.90984 11.23 5.12984 11.45L9.33984 15.69C9.80983 16.16 10.0298 16.16 10.4998 15.69C12.9498 13.21 15.4198 10.74 17.8698 8.26996C18.0898 8.04996 18.0898 7.69996 17.8698 7.47996Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5 1C5.70101 1 1 5.70101 1 11.5C1 17.299 5.70101 22 11.5 22C17.299 22 22 17.299 22 11.5C22 5.70101 17.299 1 11.5 1ZM0 11.5C0 5.14873 5.14873 0 11.5 0C17.8513 0 23 5.14873 23 11.5C23 17.8513 17.8513 23 11.5 23C5.14873 23 0 17.8513 0 11.5Z" fill="#2D2D2D"/>
                  <path d="M15.7839 15.6398L15.7838 15.6399C14.3477 17.1786 12.1871 17.7136 10.1778 17.1329L10.1775 17.1328C10.0496 17.0962 9.93279 17.1178 9.84108 17.1792C9.75174 17.239 9.69246 17.3322 9.66553 17.4305C9.6386 17.5289 9.64208 17.6395 9.68737 17.7375C9.73373 17.8379 9.8213 17.919 9.94894 17.9571L9.94981 17.9573C13.6436 19.0241 17.5364 16.5996 18.0465 12.7477C18.5564 8.91264 15.35 5.42454 11.4774 5.63168C9.36862 5.74323 7.4896 6.90639 6.38608 8.68871C6.31491 8.80149 6.3031 8.91948 6.33755 9.02432C6.37109 9.12637 6.44558 9.20777 6.53331 9.25918C6.62112 9.31064 6.72881 9.33601 6.83512 9.31806C6.94394 9.29968 7.04516 9.23673 7.11503 9.12371C8.2143 7.35151 10.2012 6.31017 12.2944 6.49486C14.3257 6.6744 16.138 8.04496 16.8769 9.94344C17.626 11.8729 17.1998 14.1264 15.7839 15.6398Z" fill="black" stroke="black" stroke-width="0.2"/>
                  <mask id="path-4-outside-1" maskUnits="userSpaceOnUse" x="4.97974" y="5.90173" width="4" height="4" fill="black">
                  <rect fill="white" x="4.97974" y="5.90173" width="4" height="4"/>
                  <path d="M5.97974 7.22623C5.97974 7.83768 5.97974 8.44913 5.97974 9.05536C5.97974 9.1442 5.97974 9.22782 5.97974 9.31666C5.97974 9.49435 6.1313 9.64068 6.30376 9.64068C6.83682 9.64068 7.36987 9.64068 7.89771 9.64068C7.9761 9.64068 8.0545 9.64068 8.13289 9.64068C8.30535 9.64068 8.46736 9.48912 8.4569 9.31666C8.44645 9.13897 8.3158 8.99265 8.13289 8.99265C7.59983 8.99265 7.06677 8.99265 6.53893 8.99265C6.46054 8.99265 6.38215 8.99265 6.30376 8.99265C6.41351 9.10239 6.52325 9.21214 6.62777 9.31666C6.62777 8.70521 6.62777 8.09376 6.62777 7.48753C6.62777 7.39869 6.62777 7.31507 6.62777 7.22623C6.62777 7.05377 6.47622 6.89176 6.30376 6.90221C6.1313 6.90744 5.97974 7.04331 5.97974 7.22623Z"/>
                  </mask>
                  <path d="M5.97974 7.22623C5.97974 7.83768 5.97974 8.44913 5.97974 9.05536C5.97974 9.1442 5.97974 9.22782 5.97974 9.31666C5.97974 9.49435 6.1313 9.64068 6.30376 9.64068C6.83682 9.64068 7.36987 9.64068 7.89771 9.64068C7.9761 9.64068 8.0545 9.64068 8.13289 9.64068C8.30535 9.64068 8.46736 9.48912 8.4569 9.31666C8.44645 9.13897 8.3158 8.99265 8.13289 8.99265C7.59983 8.99265 7.06677 8.99265 6.53893 8.99265C6.46054 8.99265 6.38215 8.99265 6.30376 8.99265C6.41351 9.10239 6.52325 9.21214 6.62777 9.31666C6.62777 8.70521 6.62777 8.09376 6.62777 7.48753C6.62777 7.39869 6.62777 7.31507 6.62777 7.22623C6.62777 7.05377 6.47622 6.89176 6.30376 6.90221C6.1313 6.90744 5.97974 7.04331 5.97974 7.22623Z" fill="black"/>
                </svg>
            </zt-tooltip>
          </button>

          <div v-if="publishedEforms.reverted === 't'"
              class="actions">
            <zt-tooltip text="Envío revertido" position="top">
              <div class="circle-icon flex justify-center items-center">
                <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.99 0.0508471C8.12984 0.174944 5.41232 1.36058 3.37646 3.39645C1.22306 5.54984 0.0104564 8.46635 2.95043e-06 11.5083L0 11.51C0 14.5632 1.21304 17.4797 3.36559 19.6427C5.52055 21.8081 8.44857 23.01 11.5 23.01C14.5524 23.01 17.4796 21.7974 19.6335 19.6436C21.7984 17.4887 23 14.5611 23 11.51L23 11.5083C22.9895 8.44747 21.7778 5.5208 19.6239 3.36675C17.469 1.20168 14.5412 0 11.49 0H10.99V0.0508471ZM11.99 1.01179V1.04001H11.49C8.71205 1.04001 6.04938 2.13773 4.08356 4.10355C2.11716 6.06995 1.00977 8.73312 1 11.5109C1.00023 14.2974 2.10717 16.9605 4.07441 18.9373C6.03945 20.9119 8.71143 22.01 11.5 22.01C14.2875 22.01 16.9603 20.9026 18.9264 18.9365L18.9273 18.9356C20.9017 16.9707 21.9998 14.299 22 11.5106C21.9902 8.712 20.8821 6.03922 18.9165 4.07355L18.9156 4.0727C17.0683 2.21646 14.5963 1.13478 11.99 1.01179Z" fill="#FF5252"/>
                  <path d="M12.5402 11.4806C13.8302 10.0806 15.1202 8.68054 16.4102 7.28054C16.9502 6.69054 16.0702 5.80055 15.5302 6.40055C14.2802 7.76055 13.0202 9.12055 11.7702 10.4905C10.5302 9.14055 9.29017 7.80055 8.05017 6.45055C7.50017 5.86055 6.62018 6.74054 7.17018 7.33054C8.46018 8.73054 9.74016 10.1205 11.0302 11.5205C9.74016 12.9205 8.45017 14.3205 7.16017 15.7205C6.62017 16.3105 7.50017 17.2005 8.04017 16.6005C9.29017 15.2405 10.5502 13.8805 11.8002 12.5106C13.0402 13.8605 14.2802 15.2005 15.5202 16.5505C16.0702 17.1405 16.9502 16.2606 16.4002 15.6706C15.1202 14.2706 13.8302 12.8806 12.5402 11.4806Z" fill="#FF5252"/>
                </svg>
              </div>
            </zt-tooltip>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <zt-modal :active="active" @close="active=false,selectedIdMaster = null">
    <template slot="modal-header">
      <div class="p-4 header-modal bg-black">
        <span class="text-lg font-bold">{{$t("message.publishedEforms.modalRevert.title")}}</span>
      </div>
    </template>
    <div class="p-4 pt-5 pb-5">
        <div class="text-lg font-semibold text-zt-dark-500	">{{$t("message.publishedEforms.modalRevert.question")}}</div>
        <div class="flex mt-4">
          <svg width="150" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="35" cy="35.1506" r="34" fill="white" stroke="#FB8C00" stroke-width="2"/>
          <path d="M34.7874 41.5049C33.8466 41.5049 33.0748 40.7331 33.0748 39.7923V20.9419C33.0748 20.0011 33.8466 19.2293 34.7874 19.2293C35.7282 19.2293 36.5 20.0011 36.5 20.9419V39.7923C36.5 40.7364 35.747 41.5049 34.7874 41.5049Z" fill="#FB8C00" stroke="#FB8C00"/>
          <path d="M34.7874 46.9324C35.7282 46.9324 36.5 47.7042 36.5 48.645C36.5 49.5858 35.7282 50.3576 34.7874 50.3576C33.8466 50.3576 33.0748 49.5858 33.0748 48.645C33.0748 47.7042 33.8466 46.9324 34.7874 46.9324Z" fill="#FB8C00" stroke="#FB8C00"/>
          </svg>
            <div class="text-lg font-normal ml-4 text-zt-dark-400">{{this.$t("message.publishedEforms.modalRevert.bodyContent")}}</div>
        </div>
    </div>
    <template slot="modal-footer" >
      <div class="flex justify-end items-center p-4 bg-gray-300	">
          <button @click="active=false,selectedIdMaster = null" class="mr-3 text-gray-700" data-vs-button="close-pub">{{this.$t("message.publishedEforms.recipientsModal.cancel")}}</button>
          <zt-button @click="revert(selectedIdMaster)" data-vs-button="revert-pub">{{$t("message.publishedEforms.modalRevert.btn_Revert")}}</zt-button>
      </div>
    </template>
  </zt-modal>
  <zt-modal :active="showTooltip" @close="showTooltip=false">
    <template slot="modal-header">
      <div class="p-4 header-modal">
        <span class="text-lg font-bold">{{$t("message.publishedEforms.recipientsModal.documentType")}} ({{countTemplates}})</span>
      </div>
    </template>
    <div class="p-3 pt-3 pb-5" style="max-height: calc(100vh - 300px);overflow-y: auto">
       <div class="items-center" v-for="(listTemplate,index) in listTemplates" :key="listTemplate.id">
        <div class="flex py-2">
          <div class="font-normal w-8 text-zt-dark-500">
            {{index+1}}
          </div>
          <div class="flex items-center">
            <div class=" font-normal">
              <zt-chip :data-vs-chip="`chip-${index}`">
                {{listTemplate}}
              </zt-chip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template slot="modal-footer" >
      <div class="flex justify-end items-center p-4 bg-gray-300	">
          <zt-button @click="showTooltip=false" data-vs-button="close-modal-doctype">{{$t("message.publishedEforms.recipientsModal.close")}}</zt-button>
      </div>
    </template>
  </zt-modal>
  <zt-modal class="zt-modal-recipients" :active="showRecipients" @close="showRecipients=false,selectedIdMaster = null,listRecipients=[]">
    <template slot="modal-header">
      <div class="p-4 header-modal">
        <span class="text-lg font-bold">{{$t("message.publishedEforms.recipientsModal.title")}} ({{countRecipients}})</span>
      </div>
    </template>
    <div class="p-3 pt-3 pb-5 relative " style="min-height: 300px;max-height: calc(100vh - 300px);overflow-y: auto">
      <vue-loading
          :active="isLoading"
          id="spinner"
          color="#4f41a3"
          duration="1.5"
          size="40"
      />
      <div class="items-center" v-for="item in listRecipients" :key="item.id">
        <div class="flex">
          <div class="w-1/12">
            <zt-avatar
              class="outlined border-avatar"
              :text="item.fullname"
              color="primary"
              size="37px"
            >
            </zt-avatar>
          </div>
          <div class="flex w-11/12 items-center">
            <div class="pl-3 font-normal">
              {{item.fullname}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template slot="modal-footer" >
      <div class="flex justify-end items-center p-4 bg-gray-300	">
          <zt-button @click="showRecipients=false,selectedIdMaster = null,listRecipients=[]" data-vs-button="close-modal-dest">{{this.$t("message.publishedEforms.recipientsModal.close")}}</zt-button>
      </div>
    </template>
  </zt-modal>
  
</div>
  
</template>

<script>
import Eforms from "../../apiClient/Eforms";
import moment from 'moment';
export default {
  name: 'TableCustom',
  props: {
    items: {
      type: Array
    }
  },
  data() {
    return {
      headerActive:'date',
      headerTableSort:{
        fullname: false,
        date:false,
        status: false,
      },
      active: false,
      selectedIdMaster:null,
      showTooltip:false,
      showRecipients:false,
      listTemplates:[],
      listRecipients:[],
      countRecipients:null,
      countTemplates:null,
      isLoading: false,
      currentIndex: 0
    }
  },
  methods: {
    revert(id){
      this.eforms
        .updatePublishedEforms(id)
        .then((response) => {
          if (response.status === 200) {
            this.$emit('reloaded-now', true)
            this.active = !this.active
            this.selectedIdMaster = null
          }
        })
        .catch((error) => {});
    },
    emitFilter(filter){
      this.headerActive = filter
      if(filter ==='fullname') this.headerTableSort.fullname = !this.headerTableSort.fullname
      if(filter ==='date') this.headerTableSort.date = !this.headerTableSort.date
      if(filter ==='status') this.headerTableSort.status = !this.headerTableSort.status
      this.$emit('sorting', filter)
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YY HH:mm')
    },
    getRecipients(id){
      this.isLoading = true
      this.$nextTick(() => {
        const loader = document.getElementById('spinner')
        loader.classList.remove('is-full-page')
      })
      this.eforms
        .getEformsPublishedRecipients(id)
        .then((response) => {
          if (response.status === 200) {
            this.listRecipients = response.data.data;
            this.isLoading = false
          }
        })
        .catch((error) => {
          this.isLoading = false
        });
    }
  },
  created(){
    this.eforms = new Eforms();
  }
}
</script>
<style scoped>
  .header-modal{
    background: #2D2D2D;
  }
  .zt-chip{
    height: 23px !important;
    border: 1px solid #cacaca;
    padding: 0.80rem !important;
  }
  .zt-chip-custom {
    border-color: #898DFF;
    background-color: #EAE8F4;
    color: #898DFF;
  }
  .fixed-height{
    width: 20rem;
  }
  .actions {
    width: 23px;
    height: 23px;
  }

</style>
